import object from '@mailobj-browser/front/js/utils/object.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'

const resolvers = new Map()

const query = async (document, names) => {
  const { defaultView } = document
  const { navigator } = defaultView
  const { permissions } = navigator
  
  for (const name of names) {
    if (!permissions.has(name)) {
      const status = await permissions.query({ name })
      
      for (const [, { resolve }] of resolvers.get(name)) {
        resolve(status)
      }
    }
  }
}

export const states = object(null, {
  denied: 'denied',
  granted: 'granted',
  prompt: 'prompt'
})

export const status = async name => {
  if (!resolvers.has(name)) {
    resolvers.set(name, resolvable())
  }
  
  const [promise] = resolvers.get(name)
  
  return promise
}

export default async element => {
  const { dataset, ownerDocument } = element
  const { permissions } = dataset
  
  await query(ownerDocument, permissions.split(','))
}
